// Main scss
import './scss/main.scss';
import 'jquery-ui/ui/widgets/sortable';

// Initialization of libs
import Masonry from './js/libs/Masonry';
import SwiperJs from './js/libs/Swiper';
import JarallaxJs from './js/libs/Jarallax';
import AosJs from './js/libs/Aos';
import ParallaxJs from './js/libs/Parallax';

// Libs
let masonry = new Masonry();
let swiper = new SwiperJs();
let jarallax = new JarallaxJs();
let aos = new AosJs();
let parallax = new ParallaxJs();

// Modules
import Extra from './js/scripts/Extra';
import Header from './js/scripts/header/Header';
import Search from './js/scripts/header/Search';
import Navigation from './js/scripts/header/Navigation';
import NavbarDropdown from './js/scripts/header/NavbarDropdown';
import NavbarFullScreen from './js/scripts/header/NavbarFullScreen';
import Forms from './js/scripts/Forms';
import GallerySocial from './js/scripts/GallerySocial';
import Counter from './js/scripts/Counter';
import Newsletter from './js/scripts/Newsletter';
import CategoryTrigger from './js/scripts/CategoryTrigger';
import Like from './js/scripts/Like';
import WoocommerceProducts from './js/scripts/woocommerce/WoocommerceProducts';
import NavigationCart from './js/scripts/woocommerce/NavigationCart';
import NavigationWishlist from './js/scripts/woocommerce/NavigationWishlist';
import WoocommerceSingleProduct from './js/scripts/woocommerce/WoocommerceSingleProduct';
import WoocommerceFavorites from './js/scripts/woocommerce/WoocommerceFavorites';
import ProductFastAccess from './js/scripts/woocommerce/ProductFastAccess';
import WoocommerceArchive from './js/scripts/woocommerce/WoocommerceArchive';
import MyAccount from './js/scripts/woocommerce/MyAccount';
import OTPWoocommerceLogin from './js/scripts/woocommerce/OTPWoocommerceLogin';
import AiRequest from './js/scripts/AiRequest';

// Init objects
let extra = new Extra();
let header = new Header();
let search = new Search();
let navigation = new Navigation();
let navbarDropdown = new NavbarDropdown();
let navbarFullScreen = new NavbarFullScreen();
let forms = new Forms();
let gallerySocial = new GallerySocial();
let counter = new Counter();
let newsletter = new Newsletter();
let categoryTrigger = new CategoryTrigger();
let like = new Like();
let woocommerceProducts = new WoocommerceProducts();
let navigationCart = new NavigationCart();
let navigationWishlist = new NavigationWishlist();
let woocommerceSingleProduct = new WoocommerceSingleProduct();
let woocommerceFavorites = new WoocommerceFavorites();
let productFastAccess = new ProductFastAccess();
let woocommerceArchive = new WoocommerceArchive();
let myAccount = new MyAccount();
let otpWoocommerceLogin = new OTPWoocommerceLogin();
let aiRequest = new AiRequest();
